/*
 * File: UICheckbox.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Wrapper for checkbox
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

const styles = {
  listItemText: {
    fontSize: "1em"
  }
};

const UICheckbox = ({ classes, option, field }) => {
  const handleChange = () => {
    option.toggle();
    field.update();
  };

  return (
    <ListItem
      className={classes.listItem}
      dense
      button
      disableRipple
      onClick={handleChange}
    >
      <ListItemText
        primaryTypographyProps={{ className: classes.listItemText }}
        primary={option.name}
      />
      <Checkbox
        disableRipple
        checked={option.selected === true}
        className={classes.checkbox}
        color="primary"
      />
    </ListItem>
  );
};

UICheckbox.propTypes = {
  classes: PropTypes.object.isRequired,
  option: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired
};

export default withStyles(styles)(observer(UICheckbox));
